import { DomainEvent } from '@frontend/sports/common/core/utils/dispatcher';

import { PickId } from '../../../betslip/core/picks/pick-id';

/* tslint:disable variable-name */

export class BaseBetslipEvents {
    static BetslipPluginStateChanged = new DomainEvent<void>('BETSLIP_PLUGIN_STATE_CHANGED');
    static Initialized = new DomainEvent<{ [key: string]: PickId }>('BETSLIP_INITIALIZED');
    static HomeMarqueAddPick = new DomainEvent<PickId>('homeMarquee/add-pick-by-id');
    static BetPlaceSuccess = new DomainEvent<void>('BET_PLACE_SUCCESS');
}

export class BaseBetslipActions {
    static RemoveAllPicks = new DomainEvent<{ selected?: boolean; visible: boolean }>('BETSLIP_REMOVE_ALL_PICKS');
}

export interface PicksChangedData {
    count: number;
    auto: boolean;
    afterBetPlacement?: boolean;
}
